<template>
  <transition name="resource-notifications-create-modal">
    <div
      v-if="isVisible"
      :class="{ 'is-active' : isVisible }"
      class="modal"
    >
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-content resource-notifications-create-modal__content" :class="currentStep">
        <div class="box">
          <div class="columns is-mobile is-multiline">
            <div class="column is-11 has-border-bottom pb-1">
              <span class="is-size-4 has-text-weight-medium">
                {{ $t('resourceNotificationsCreateModal.title') }}
              </span>
            </div>
            <div class="column is-1 has-text-right has-border-bottom pb-1">
              <button class="delete" @click="closeModal"></button>
            </div>
            <create-form
              v-if="isFormStep"
              v-model="resourceNotification"
              class="column is-half"
              style="height: 80%;"
              :resource="resource"
            />
            <create-preview
              v-if="isFormStep"
              class="column is-half"
              :resource-notification="resourceNotification"
              :resource="resource"
            />
            <create-recipients-chooser
              v-if="isRecipientsStep"
              v-model="resourceNotification.user_ids"
              class="column is-full"
            />
            <div
              class="column is-full has-border-top is-flex actions"
              :class="{
                'is-justify-content-flex-end': isFormStep,
                'is-justify-content-space-between': isRecipientsStep,
              }"
            >
              <a
                v-if="isFormStep"
                class="button is-primary is-rounded"
                :disabled="!isResourceNotificationValid"
                @click="onSendClick"
              >
                <span>{{ $t('resourceNotificationsCreateModal.buttons.send') }}</span>
                <span class="icon">
                  <fa-icon :icon="['fas', 'chevron-right']" />
                </span>
              </a>
              <a
                v-if="isRecipientsStep"
                class="button is-light is-rounded"
                @click="onBackToFormClick"
              >
                <span class="icon">
                  <fa-icon :icon="['fas', 'chevron-left']" />
                </span>
                <span>{{ $t('resourceNotificationsCreateModal.buttons.backToForm') }}</span>
              </a>
              <a
                v-if="isRecipientsStep"
                class="button is-primary is-rounded"
                :class="{ 'is-loading': isLoading }"
                :disabled="!hasRecipientsSelected"
                @click="onCreateClick"
              >
                <span class="icon">
                  <fa-icon :icon="['fas', 'share-alt']" />
                </span>
                <span>{{ $t('resourceNotificationsCreateModal.buttons.create') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import CreateForm from './CreateForm.vue'
import CreatePreview from './CreatePreview.vue'
import CreateRecipientsChooser from './CreateRecipientsChooser.vue'

const STEPS = { form: 'form', recipients: 'recipients' }

export default {
  name: 'ResourceNotificationsCreateModal',
  components: { CreateForm, CreatePreview, CreateRecipientsChooser },
  data: () => ({
    resourceNotification: {
      include_metadata: true,
      user_ids: []
    },
    currentStep: STEPS.form,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      isVisible: 'resource_notifications_create_modal/isVisible',
      resource: 'resource_notifications_create_modal/currentResource'
    }),
    isFormStep() { return this.currentStep === STEPS.form },
    isRecipientsStep() { return this.currentStep === STEPS.recipients },
    isResourceNotificationValid() { return this.resourceNotification.title },
    hasRecipientsSelected() { return this.resourceNotification.user_ids.length > 0 }
  },
  watch: {
    resource(newResource) {
      if (newResource) {
        this.resourceNotification.resource_id = newResource.id
        this.resourceNotification.title = newResource.metadata.default.title
        this.resourceNotification.medium_ids = this.initialMediumIds(newResource)
        this.resourceNotification.include_text = this.initialIncludeText(newResource)
      }
    }
  },
  methods: {
    closeModal() {
      this.currentStep = STEPS.form
      this.$store.dispatch('resource_notifications_create_modal/close')
    },
    initialMediumIds(resource) {
      switch(resource.type) {
        case 'newspaper':
        case 'magazine':
          return this.resource.advertorial.pages.map(page => page.medium.id)
        case 'website':
          return []
        case 'social':
          return this.resource.advertorial.media.map(medium => medium.id)
      }
    },
    initialIncludeText(resource) {
      return resource.type !== 'magazine'
    },
    onSendClick() {
      if (!this.isResourceNotificationValid) { return }

      this.currentStep = STEPS.recipients
    },
    onBackToFormClick() {
      this.resourceNotification.user_ids = []
      this.currentStep = STEPS.form
    },
    onCreateClick() {
      if (!this.isResourceNotificationValid) { return }

      this.isLoading = true
      this.$repositories()
          .resourceNotifications
          .create(this.resourceNotification)
          .then(() => {
            this.$_notify({
              text: this.$t('resourceNotificationsCreateModal.resource_notifications_created'),
              type: 'success'
            })
            this.closeModal()
          })
          .catch(() => {
            this.$_notify({
              text: this.$t('resourceNotificationsCreateModal.resource_notifications_failed'),
              type: 'danger'
            })
          })
          .finally(() => { this.isLoading = false })
    }
  }
}
</script>
<style>
.resource-notifications-create-modal__content.form {
  width: 70% !important;
}

.resource-notifications-create-modal__content.recipients {
  width: 60% !important;
}

.resource-notifications-create-modal__content .actions {
  position: sticky;
  background-color: white;
  bottom: 0;
}

.resource-notifications-create-modal-enter-active,
.resource-notifications-create-modal-leave-active {
  transition: all 0.2s;
}
.resource-notifications-create-modal-enter,
.resource-notifications-create-modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>